(function() { window.GUID_2131c3a3_b561_4bab_9ae0_18ae1945208d = { getGuid: function() { return "2131c3a3-b561-4bab-9ae0-18ae1945208d"; } }; })();
var CS;
(function (CS) {
    var Helper;
    (function (Helper) {
        let dropDownInstances;
        let DropDownInstances;
        (function (DropDownInstances) {
            //Cette fonction maintient une liste d'instances de tous les dropdowns 
            //qui existe dans la page pour ainsi en faire une gestion performante.
            //Seule une instance sera ajouté même si elle la fonction est appelé 
            //plusieurs fois avec cette même instance
            //La fonction fait aussi en sorte de maintenair seulement la derniere
            //version d'un dropdown, donc,apres un refresh ajax, celle-ci sera mise à
            //jour par les nouvelles instances
            function AddInstance(dropDown) {
                if (!dropDownInstances) {
                    dropDownInstances = new Array();
                }
                let instanceOfSameId = getInstanceOfSameId(dropDown);
                if (instanceOfSameId != dropDown) {
                    RemoveInstance(instanceOfSameId);
                    dropDownInstances.push(dropDown);
                }
            }
            DropDownInstances.AddInstance = AddInstance;
            function RemoveInstance(dropDown) {
                let index = dropDownInstances.indexOf(dropDown);
                if (index > -1) {
                    dropDownInstances.splice(index, 1);
                }
            }
            DropDownInstances.RemoveInstance = RemoveInstance;
            function HideOtherInstances(currentDropDown) {
                $.each(dropDownInstances, function (i, dropDown) {
                    if (currentDropDown != dropDown) {
                        if (!currentDropDown || !currentDropDown.isDescendantOf(dropDown)) {
                            dropDown.Close();
                        }
                    }
                });
            }
            DropDownInstances.HideOtherInstances = HideOtherInstances;
            function getInstanceOfSameId(dropDown) {
                let exist = $.grep(dropDownInstances, function (d) {
                    return dropDown.ControlId === d.ControlId;
                });
                if (exist.length > 0) {
                    return exist[0];
                }
                return null;
            }
            let binded = false;
            function BindEvents(id) {
                CS.DOM.$win.offon('scroll.dropdown-' + id, function () {
                    $.each(dropDownInstances, function (i, dd) {
                        dd.RefreshDropDownLayout(false);
                    });
                }).offon('mousedown.dropdown-' + id, function (e) {
                    let dropDown = testIfIsADropDown(e.target);
                    let picker = testIfIsAPicker(e.target);
                    let $testButtonBack = $(e.target);
                    if ($testButtonBack[0].id == '#button-back' || $testButtonBack.closest('#button-back').length > 0) {
                        return;
                    }
                    if (!picker) {
                        HideOtherInstances(dropDown);
                    }
                }).offon('resize.dropdown-' + id, function () {
                    $.each(dropDownInstances, function (i, dd) {
                        dd.RefreshDropDownLayout(false);
                    });
                });
            }
            DropDownInstances.BindEvents = BindEvents;
            function OnDispose(id) {
                CS.DOM.$win.off('scroll.dropdown-' + id).off('mousedown.dropdown-' + id).off('resize.dropdown-' + id);
            }
            DropDownInstances.OnDispose = OnDispose;
            function testIfIsADropDown(target) {
                let $target = $(target);
                let $dropDown = $target.is('.dropdown') ? $target : null;
                if (!$dropDown) {
                    $dropDown = $target.closest('.dropdown');
                }
                if ($dropDown && $dropDown.length > 0) {
                    let dropDown = CS.Controls.GetInstance(CS.Controls.DropDown, $dropDown, true);
                    return dropDown;
                }
                return null;
            }
            function testIfIsAPicker(target) {
                let $target = $(target);
                let $picker = $target.is('.dropdown-picker') ? $target : null;
                if (!$picker) {
                    $picker = $target.closest('.dropdown-picker');
                }
                if ($picker && $picker.length > 0) {
                    let picker = CS.Controls.GetInstance(CS.Controls.DropDownPicker, $picker, true);
                    return picker;
                }
                return null;
            }
        })(DropDownInstances = Helper.DropDownInstances || (Helper.DropDownInstances = {}));
    })(Helper = CS.Helper || (CS.Helper = {}));
})(CS || (CS = {}));

//# sourceMappingURL=dropdown-instances-helper.js.map
